import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import { errorParaTi, getParaTi, successParaTi } from '../actions';

@Injectable()
export class ParaTiEffets {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
    ) { }

    public getParaTi$ = createEffect(
        () => this.actions$.pipe(
            ofType(getParaTi),
            map((actions) => ({ ...actions, Version: environment.versionNumber })),
            switchMap((actions) =>
                this.httpS.executeFunctionDataUser(actions.api, { Version: actions.Version })
                    .pipe(
                        map(resp => successParaTi(resp)),
                        catchError((err: Error) => of(errorParaTi({ payload: err })))
                    )
            )
        )
    );

}